import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('token');
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchUser();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUser = async () => {
    try {
      const response = await api.get('/auth/me');
      setUser(response.data.admin);
    } catch (error) {
      console.error('Failed to fetch user:', error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (username, password, totpCode = null) => {
    const response = await api.post('/auth/login', { username, password, totpCode });

    // Check if 2FA is required
    if (response.data.requiresTwoFactor) {
      return { requiresTwoFactor: true };
    }

    const { token, admin } = response.data;

    localStorage.setItem('token', token);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(admin);

    return admin;
  };

  const logout = () => {
    localStorage.removeItem('token');
    delete api.defaults.headers.common['Authorization'];
    setUser(null);
  };

  const refreshAdmin = async () => {
    try {
      const response = await api.get('/auth/me');
      setUser(response.data.admin);
      return response.data.admin;
    } catch (error) {
      console.error('Failed to refresh admin:', error);
      return null;
    }
  };

  const value = {
    user,
    admin: user, // Alias for consistency
    loading,
    login,
    logout,
    refreshAdmin
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
